export default __webpack_public_path__ + "media/zurb/img/about/bryan/bryan-img2-0f47c9d24fbf3911851ee9e71c0831af.png";